// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
import device from "vue-device-detector";
import BootstrapVue from 'bootstrap-vue'
import NowUiKit from './plugins/now-ui-kit';
import store from './store';
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueClipboard from 'vue-clipboard2';
import ga from './ga';

Vue.use(BootstrapVue)
Vue.use(NowUiKit);
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(device);
Vue.use(VueClipboard);

AOS.init();

Vue.config.productionTip = false
/* eslint-disable no-new */

new Vue({
  el: '#app',
  store,
  i18n,
  render: h => h(App),
  router,
  mounted: async function () {
    let parameters = this.$route.query;

    let urlParam = '?';
    if (parameters.utm_source != null) {
      urlParam += "utm_source=" + parameters.utm_source;
    }
    if (parameters.utm_medium != null) {
      if (urlParam != '?') {
        urlParam += "&";
      }
      urlParam += "utm_medium=" + parameters.utm_medium;
    }
    if (parameters.ref != null) {
      if (urlParam != '?') {
        urlParam += "&";
      }
      urlParam += "ref=" + parameters.ref;
    }
    localStorage.parameters = JSON.stringify(parameters);
    if (urlParam == '?') {
      urlParam = '';
    }
    localStorage.urlParam = urlParam;

    ga.gaEvent('event', 'load');
  }
}).$mount('#app')
